import { createChecklistApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

// The task checklist's API (templates, the committed-task amendment, evidence
// photos — a check item's or a task comment's) bound to the web transport — the
// shared factory's pattern.
export const { fetchChecklistTemplates, amendTaskChecklist, uploadChecklistPhoto, uploadCommentPhoto, fetchChecklistPhoto } =
  createChecklistApi(authedFetch);
export { ChecklistIncompleteError, ChecklistTickRefusedError, type IChecklistTemplate } from '@d-orca/shared/client/apis';
